export const regionsPerAccountKeys = {
  regionsPerAccount: (accountId: string) =>
    ['regionsPerAccount', accountId] as const,
}
